import React, {useState} from "react";
import { Tooltip, IconButton, Box, Typography, useMediaQuery } from "@mui/material";
import LayersIcon from "@mui/icons-material/Layers";
import StraightenIcon from '@mui/icons-material/Straighten';
import InfoIcon from "@mui/icons-material/Info";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import logo from "../../../../assets/images/logo.svg";
import topBarStyle from "./topBarStyle";
import { measurementTool } from "../../../../utils/measurementTool.js";
import { useTheme } from "@mui/material/styles";

const TopBar = ({toggleTreeView, toggleInfoMode, isInfoMode, toggleFeedback, isTreeViewVisible, isFeedbackOpen}) => {
    const classes = topBarStyle();
    const [isMeasuring, setIsMeasuring] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const toggleMeasurement = () => {
        setIsMeasuring(!isMeasuring);
        if (window.viewer) {
            if (window.viewer && window.viewer.scene && Object.keys(window.viewer.scene.models).length > 0) {
                measurementTool(window.viewer, !isMeasuring);
            } else {
                console.error("❌ Viewer is not initialized or no model loaded.");
            }
        };
    };
        // Function to toggle Info Mode (ensuring Measurement is deactivated)
        const handleToggleInfo = () => {
            if (isInfoMode) {
                toggleInfoMode();
            } else {
                if (isMeasuring) {
                    setIsMeasuring(false); // Ensure Measurement Tool is deactivated
                }
                toggleInfoMode();
            }
        };
    return(
    <Box className={classes.topBarContainer}>
        {/* Logo & Name (Hidden in Mobile) */}
        {!isMobile && (
           <Box className={classes.logoContainer}>
                <img src={logo} alt="Logo" className={classes.logo} />
                <Typography className={classes.logoText}>PaketPost Horizons</Typography>
            </Box>
             )}

            {/* Layers Button */}
             <Tooltip title="Layers" arrow>
                <IconButton className={`${classes.iconButton} ${isTreeViewVisible ? classes.activeButton : ""}`}
                 onClick={toggleTreeView}>
                    <LayersIcon className={classes.icon} />
                </IconButton>
             </Tooltip>
             {/* Measurement Button */}
             <Tooltip title="Measurement Tool" arrow>
                <IconButton className={`${classes.iconButton} ${isMeasuring ? classes.activeButton : ""}`} onClick={toggleMeasurement}>
                    <StraightenIcon className={classes.icon} />
                </IconButton>
             </Tooltip>
            {/* Entity Interaction Button */}
            <Tooltip title="Entity Info" arrow>
                <IconButton className={`${classes.iconButton} ${isInfoMode ? classes.activeButton : ""}`}
                            onClick={handleToggleInfo}>
                    <InfoIcon className={classes.icon} />
                </IconButton>
            </Tooltip>

            {/* Feedback Button */}
            <Tooltip title="Give Feedback" arrow>
                <IconButton className={`${classes.iconButton} ${isFeedbackOpen ? classes.activeButton : ""}`} onClick={toggleFeedback}>
                    <ThumbUpAltIcon className={classes.icon} />
                </IconButton>
             </Tooltip>

        </Box>
    );
};
export default TopBar;
